import Apps from "@base/data/Apps";
// import SmallBanner from "@components/common/SmallBanner";
import Text from "@components/common/Text";
import Title from "@components/common/Title";
import Layout from "@components/layouts/Layout";
import HeroSection from "@components/newVersion/HeroSection";
import Applications from "@components/sections/Applications";
import React from "react";

export default function Index() {
    // Filtramos las aplicaciones para mostrar solo las habilitadas
    const appsList = Apps.filter((a) => a.enabled);

    return (
        <>
            <Layout
                mode="fixed"
                seo={{
                    title: "Nuestras aplicaciones",
                    description:
                        "Aplicaciones para Android e iOS para preparar Oposciones de Correos, Cuerpo Nacional de Policía, Guardia Civil, Guàrdia Urbana de Barcelona, Mossos d'Esquadra, etc.",
                    image: "https://www.iopos.es/images/bgs/bgApps4.jpg",
                }}
            >
                <HeroSection
                    filename={"bgs/bgApps4"}
                    firstTitle={"Nuestras aplicaciones"}
                    secondTitle={"Una aplicación para cada Oposición."}
                    thirdTitle={
                        "Entrena con metodología, analiza tu evolución y mejora cada semana con herramientas diseñadas para opositores exigentes."
                    }
                    showScrollDownIcon={true}
                />

                <div className="container py-20">
                    <Title>Aplicaciones disponibles</Title>
                    <Text>
                        Listado con las aplicaciones disponibles en este
                        momento. En breve iremos actualizando con más
                        Oposiciones y nuevas funcionalidades.
                    </Text>

                    <div className="mt-10">
                        <Applications items={appsList} />
                    </div>
                </div>
            </Layout>
        </>
    );
}
